import { jsx as _jsx } from "react/jsx-runtime";
import { styled, LinearProgress } from "@mui/material";
import { convertPxToRem } from "../../../../util-functions";
export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
    backgroundColor: theme.palette.green03.main,
    "& .MuiLinearProgress-bar": {
        backgroundColor: theme.palette.green06.main,
        borderRadius: convertPxToRem(99),
    },
}));
export const DataGridProLoadingOverlay = () => _jsx(StyledLinearProgress, {});
